import { EventBus } from '@/event-bus'
import { Events } from '@/models/events.model'
import { Artifact, asSnapshotReference } from '@/models'

import GraphState from './../rappid/graph-state'

import { useRoute } from 'vue-router'
import { freezeWrap, tryWrap, useEventBus } from '@/utils/events'
import { useTraceDataStore } from '@/stores/traceDataStore'

import { parseIntUndefined } from '@/utils/helpers'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export function useRegisterLoadArtifactsAfterExpand() {
  const route = useRoute()
  const traceDataStore = useTraceDataStore()

  const rappidContext = injectTyped(ServiceKeys.rappidContext)
  const artifactService = injectTyped(ServiceKeys.artifact)

  let graphState: GraphState | undefined = undefined

  async function handler(event: Events['loadArtifactsFromApiAfterExpand']) {
    if (!graphState || !route.params.projectId || !route.params.snapshotId) {
      throw Error('Missing data for rendering tracegraph')
    }

    await traceDataStore.loadArtifactsCollectionFromApi({
      artifactService: artifactService,
      projectId: parseInt(route.params.projectId as string),
      snapshotId: asSnapshotReference(route.params.snapshotId),
      typeId: event.artifactType.id,
      filterId: parseIntUndefined(route.query.filter as string),
      //include: 'numberOfLinksAsA, numberofLinksAsB',
      sortBy: 'LINK',
      page: 1,
      pageSize: 15,
    })

    // Increment the the loaded pages count to make sure the next page is loaded after a 'add more' pill press.
    // This also makes sure the next toggle collapse container event will actually expand the container.
    event.artifactType.loadedPages = 1

    await Promise.all(
      traceDataStore.modelState.artifacts
        .filter((a: Artifact) => a.artifactType.id === event.artifactType.id)
        .map(async (a: Artifact) => {
          await traceDataStore.updateTraceDataFromApi({
            artifactService: artifactService,
            projectId: parseInt(route.params.projectId as string),
            snapshotId: asSnapshotReference(route.params.snapshotId),
            filterId: parseIntUndefined(route.query.filter as string),
            id: a.id,
            direction: 'any',
          })
        }),
    )

    graphState.addToModel(traceDataStore.modelState).layout()

    // After all the data has been loaded, run toggle container again.
    EventBus.emit('updateContainerToggleCollapse', event)
  }

  function registerLoadArtifactsAfterExpand(graph: GraphState | undefined) {
    graphState = graph
  }

  useEventBus('loadArtifactsFromApiAfterExpand', freezeWrap(tryWrap(handler), rappidContext))

  return { registerLoadArtifactsAfterExpand }
}
